// extracted by mini-css-extract-plugin
export default {"checkboxButton":"CheckboxInput_checkboxButton__9+MvC","checkboxButtonDisabled":"CheckboxInput_checkboxButtonDisabled__jB1W4"};